import jQuery from 'jquery';

const text = `
<div class="upper mb5">
  <b>Your web browser ({brow_name}) is out of date</b>
</div>
<div class="gray-mid">For more security, comfort, and the best experience on this site:
    <div class="visible-sm visible-xs"></div>
    <a \{up_but\}>Update your browser</a>
    <a \{ignore_but\}>Ignore</a>
</div>`;

window.$buoop = {
  vs: {i: 10, f: -4, o: -4, s: 8, c: -4},
  api: 4,
  l: 'en',
  text,
};

jQuery(() => {
  const e = document.createElement('script');
  e.src = '//browser-update.org/update.min.js';
  document.body.appendChild(e)
});